<div class="container">
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" autocomplete="off">
        <input autocomplete="false" name="hidden" type="text" style="display:none;">

        <div class="create-password-header">
            <h2>Create new password</h2>
            <p class="primary-text">Set a password for your user account</p>
        </div>

        <div class="create-password-body">

            <div class="form-control-group">

                <div class="title-and-error-row">
                    <label class="primary-text" for="newPassword">New password</label>
                    <span class="required">*</span>    
                </div>

                <input autofocus type="{{ showPassword ? 'text' : 'password' }}" class="input-control"
                    placeholder='New password' formControlName="newPassword" autocomplete="new-password">

                <ds-icon name="eye" *ngIf="passwordForm.controls['newPassword'].value" [size]="20" class="svg-eye" (click)="toggleShowPassword()"
                    [ngClass]="{ 'active': showPassword }">
                </ds-icon>

                <!-- <svg class="svg-eye" (click)="toggleShowPassword()" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="16" viewBox="0 0 22 16">
                    <defs>
                        <path d="M10 13c6.23 0 10-5.25 10-6.5S16.25 0 10 0 0 5.25 0 6.5 3.77 13 10 13z" id="mrk4hokfea" />
                    </defs>
                    <g transform="translate(1 1.5)" fill="none" fill-rule="evenodd">
                        <mask id="tj25rw47ob" fill="#fff">
                            <use xlink:href="#mrk4hokfea" />
                        </mask>
                        <use fill="#C8C8C8" stroke="#C8C8C8" stroke-width="1.75" stroke-linecap="round"
                             stroke-linejoin="round" xlink:href="#mrk4hokfea" />
                        <circle stroke="#FFF" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"
                                mask="url(#tj25rw47ob)" cx="10" cy="6.5" r="3.5" />
                    </g>
                </svg> -->

            </div>

            <div class="validation-fields">

                <div class="field" *ngFor="let field of validationFields; let index = index" [ngClass]="{
                'field-active': passwordForm.value.newPassword | validationPipe: validationFields[index].regularExp
                }">

                    <span class="tick">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM8.38366 13.0583L14.0671 6.49078L12.9329 5.50922L8.2317 10.9417L4.99118 8.13323L4.00879 9.26677L8.38366 13.0583Z" 
                                stroke="#FFFFFF" fill-rule="evenodd" clip-rule="evenodd"/>
                        </svg>
                    </span>
                    <p class="field-text">
                        {{field.title}}
                    </p>

                </div>

            </div>

            <div class="form-control-group">

                <div class="title-and-error-row">
                    <label class="primary-text" for="confirmPassword">
                        Confirm new password
                    </label>
                    <span class="required">*</span>    
                </div>

                <input type="password" 
                    class="input-control" 
                    formControlName="confirmPassword"
                    placeholder="Confirm new password"
                    autocomplete="new-password"
                    [ngClass]="{ 'input-touched' : passwordForm.controls['confirmPassword'].touched && passwordForm.controls['confirmPassword'].errors }">

                    

                <span class="tick tick-confirm" *ngIf=" passwordForm.controls['confirmPassword'].touched
                && !passwordForm.controls['confirmPassword'].errors && !!passwordForm.value.newPassword
                ">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12">
                        <path d="M2 6.244 6.225 10 12 2" stroke="#28C840" stroke-width="2.5" fill="none"
                            fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </span>

                <div class="title-and-error-row">
                    <span class="error" *ngIf="passwordForm.controls['confirmPassword'].touched
                    && passwordForm.controls['confirmPassword'].errors">
                        Passwords do not match
                    </span>
                </div>
            </div>

        </div>

        <ds-button
                class="button-submit"
                type="submit" 
                [isDisabled]="!passwordForm.valid"
                [ngClass]="{ 'disabled-button': !passwordForm.valid}"
                [isLoading]="isLoading" 
                [processingText]="'Setting password...'" >
            Set password
        </ds-button>

    </form>
</div>